import mixpanel from 'mixpanel-browser';
import { isNonNil } from '../fn';
import { Category, EventName } from './analyticsCore';

let isMixpanelInitialized = false;

/**
 * 개발 환경에서만 로그를 출력합니다.
 * @param args 로그에 출력할 인자들
 */
const debugLog = (...args: unknown[]) => {
  const isDebugEnabled =
    process.env.NODE_ENV === 'development' ||
    process.env.NEXT_PUBLIC_PHASE === 'dev' ||
    process.env.NEXT_PUBLIC_PHASE === 'sandbox';
  if (isDebugEnabled) {
    console.log(...args);
  }
};

/**
 * Mixpanel을 초기화합니다.
 * @param token Mixpanel 프로젝트 토큰
 * @param userId 사용자 ID (선택 사항)
 */
export const initMixpanel = (token: string, userId?: number) => {
  if (typeof window !== 'undefined') {
    const isDebugEnabled =
      process.env.NODE_ENV === 'development' ||
      process.env.NEXT_PUBLIC_PHASE === 'dev' ||
      process.env.NEXT_PUBLIC_PHASE === 'sandbox';
    mixpanel.init(token, { debug: isDebugEnabled });
    if (isNonNil(userId)) {
      mixpanel.identify(String(userId)); // 사용자 식별
    }
    isMixpanelInitialized = true;
    debugLog('Mixpanel 초기화됨');
  }
};

/**
 * Mixpanel에 이벤트를 전송합니다.
 * @param eventName 이벤트 이름
 * @param properties 이벤트 속성
 */
export const trackMixpanelEvent = <T extends Category>(
  eventName: EventName<T>,
  properties: Record<string, unknown>
) => {
  if (typeof window === 'undefined' || !isMixpanelInitialized) return;
  mixpanel.track(eventName, properties);
  debugLog('Mixpanel 이벤트 전송:', eventName, properties);
};

/**
 * Mixpanel 사용자 ID를 설정합니다.
 * @param userId 설정할 사용자 ID
 */
export const setMixpanelUserId = (userId: number) => {
  if (typeof window === 'undefined' || !isMixpanelInitialized) return;
  mixpanel.identify(String(userId));
  debugLog('Mixpanel 사용자 ID 설정:', userId);
};

/**
 * Mixpanel 사용자 프로필 속성을 설정합니다.
 * @param properties 설정할 사용자 프로필 속성
 */
export const setMixpanelUserProperties = (
  properties: Record<string, unknown>
) => {
  if (typeof window === 'undefined' || !isMixpanelInitialized) return;
  if (mixpanel.people) {
    mixpanel.people.set(properties);
    debugLog('Mixpanel 사용자 속성 설정:', properties);
  }
};
